export default {
	NONE: 'none',
	WHITEBOARD: 'whiteboard',
	ANNOTATE: 'annotate',
}
